const validToken = require("../../commons/guards").validToken;
export { validToken };
